<template>
    <div>
        <div class="px-3 py-2">
            <b-sidebar aria-labelledby="sidebar-no-header-title" width="700px" no-header id="import_file" backdrop style="direction:ltr" right :title="lang.add_new_account" shadow >
                <template #default="{ hide }">
                    <div class="m-1 text-start" style="direction:rtl">
                        <div style="width:140px;margin-right:10px;background:#000;color:#FFF;border-radius:5px" class="btn-primary btn-sm text-center">
                            <span style="font-size:.8em;">استيراد</span>
                        </div>
                        <div @click="hide" id="dhideExp" style="width:100px;text-align:center;float:left;margin-left:5px;margin-top:-25px;cursor:pointer" class="btn-danger btn-sm">
                            <span>{{lang.close}}</span>
                        </div>
                    </div>
                    <v-divider></v-divider>
                    <div class="px-3 py-2" :style="`direction:`+lang.dir">
                        <v-row>
                            <v-col cols="8">
                                <b-form-file class="inborder" type="file" v-model="fileit" @change="handleFileUpload" />
                            </v-col>
                            <v-col cols="4">
                                <button @click="downloadSamle()">تحميل نموذج الاكسل</button>
                            </v-col>
                        </v-row>
                    </div>
                </template>
                <template #footer="" class="shadow">
                    <div class="d-flex text-light align-items-center px-3 py-2">
                        <b-button type="button" variant="success" @click="uploadFile()" class="ma-2" style="width:100px;">استيراد</b-button>
                    </div>
                </template>
            </b-sidebar>

        </div>
    </div>
</template>

<script>
/* global XLSX */
import axios from 'axios';
export default {
    data() {
        return {
            /** 
             * 0 for nothing 
             * 1 for coa, 2 for jentries,
             * 3 for open balance 
             * 4 for invoices, 5 for purchase, 
             * 6 for expense, 
             * 7 for inventory
             * 8 for inventory history
             * 9 for inventory transaction between stores 
             * */
            type: 1, 
            /**
             * 1: add new without affect others and can be modify others
             * 2: truncate tables and create new from scratch
             */
            uploadMethod: 1,
            selectedFile: null,
            fileit: null,

        }
    },
    computed: {
        lang: function () {
            if(this.$cookies.get(this.$store.state.LangCooki) != null){
                if(this.$cookies.get(this.$store.state.LangCooki)  == 'en'){
                return this.$store.state.lang.en;
                }else{
                return this.$store.state.lang.ar;
                }
            }
            else if(this.$store.state.deflang == 'en'){
                return this.$store.state.lang.en;
            }else{
                return this.$store.state.lang.ar;
            }
        },
        samples: function () {
            return [
                [],
                [ // chart of account 1
                    [
                        'account #', 'account name arabic', 'account name en', 'parent #', 'account type (main/details)',
                        'account value (debit/credit)', 'report type (balance sheet/ income statement)', 'integrated'
                    ]
                ],
                [ // jentry 2
                    [
                        'date', 'jv #', 'account number' , 'debit', 'credit', "notes", 
                        "cost center name (will be added if not exist)",
                        "overall note", "jentry type(customers, vendors, employee, fixed assets, or empty)",
                        "item id (ex. if customer go to customer list and get its id)",
                        "item name (ex. if customer customer name)", 
                        "item vatid (ex. if customer or vendor add its vatid)",
                        "item crt number (like vatid)"
                    ],
                ],
                [ // open balance 3
                    [
                        'date', 'jv #', 'account number' , 'debit', 'credit', "notes", 
                        "cost center name (will be added if not exist)",
                        "overall note", "jentry type(customers, vendors, employee, fixed assets, or empty)",
                        "item id (ex. if customer go to customer list and get its id)",
                        "item name (ex. if customer customer name)", 
                        "item vatid (ex. if customer or vendor add its vatid)",
                        "item crt number (like vatid)"
                    ],
                ],
                [ // in come voutcher 4
                    [
                        'date', 'voutcher type (customers, vendors, employees, invoice, job_card, others)', 
                        'mobile (for customer, for vendor use same mobile in their accounts, and if employee his mobile, or others any mobile )', 
                        'full name', 'amount', 'pay type (use same name in payment types)', 'account number', 'voutcher notes'
                    ],
                ],
                [ // expence voutcher 5
                    [
                        'date', 'voutcher type (customers, vendors, employees, invoice, job_card, others)', 
                        'mobile (for customer, for vendor use same mobile in their accounts, and if employee his mobile, or others any mobile )', 
                        'full name', 'amount', 'pay type (use same name in payment types)', 'account number', 'voutcher notes'
                    ],
                ],
                [ // purchase 6
                    [
                        'date', 'invoice number', 
                        'vendor mobile', 'vendor name', 'vendor vat id', 'vendor address',
                        'invoice type (1 for cash, 2 for credit)', 'item number', 'item name',
                        'item price', 'discount', 'quantity', 'total ex. of vat', 'vat amount', 'total in. vat',
                        'pay type (use same name in payment types)', 'نوع الفاتورة (للمشتريات 1 او 2 اصول ثاتبة)'
                    ],
                ],
                [ // invoices 7
                    [
                        'date', 'invoice number', 
                        'item id', 'item name', 'item unit (use 1 for piece)',  
                        'customer mobile', 'customer name', 'customer type (1 for indivisual, 2 for company, 3 for government)',
                        'company name', 'address', 'vat number' , 'crt number', 'entity name', 'branch name',
                        'invoice type (1 for cash, 2 for credit)', 'pay type (use same name in payment types)',
                        'item price', 'discount', 'quantity', 'total ex. of vat', 'vat amount', 'total in. vat', 'notes',
                        "plate number", "car brand", "car name" , "car model" , "car color" , "car VIN", "car engin meter", "item type (1 spare part, 2 service)"
                    ],
                ],
                [ // customers 8
                    [
                        'customer mobile', 'customer name', 'customer type (1 for indivisual, 2 for company, 3 for government)',
                        'company name', 'address', 'vat number' , 'crt number', 'building number', 'street name', 'branch number',
                        'district', 'zip code'
                    ],
                ],
                [ // expenses 9
                    [
                        'date', 'invoice number', 
                        'vendor mobile', 'vendor name', 'vendor vat id', 'vendor address',
                        'invoice type (1 for cash, 2 for credit)', 'item name',
                        'item price', 'discount', 'quantity', 'total ex. of vat', 'vat amount', 'total in. vat',
                        'pay type (use same name in payment types)',
                    ],
                ]
            ];
        },
        uploadMethods: function(){
            return [
                {text: this.lang.add_new_row, value: 1},
                {text: this.lang.delete_old, value: 2},
            ]
        }
    },
    methods: {
        downloadSamle() {
            const ws = XLSX.utils.aoa_to_sheet(this.samples[this.type]);
            const wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, "Sheet 1");
            XLSX.writeFile(wb, "file sample.xlsx");
        },

        handleFileUpload(event) {
            const file = event.target.files[0];
            const allowedTypes = [
                "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", // .xlsx
                "application/vnd.ms-excel" // .xls
            ];

            if (!allowedTypes.includes(file.type)) {
                alert("Please upload a valid Excel file (.xls or .xlsx).");
                this.selectedFile = null;
                return;
            }

            this.selectedFile = file;
        },
        async uploadFile() {

            if (!this.selectedFile) {
                alert("No file selected.");
                return;
            }

            const post = new FormData();

            post.append('type',"importExcelFile");
            post.append('defBranch',localStorage.getItem('defBranch'));
            post.append('financeYear',localStorage.getItem('financeYear'));
            post.append('defBranch',localStorage.getItem('defBranch'));
            post.append('financeYear',localStorage.getItem('financeYear'));
            post.append('auth',this.$cookies.get(this.$store.state.COOKIEPhase));
            post.append('data[lang]',this.$cookies.get(this.$store.state.LangCooki));
            post.append('data[file]',this.selectedFile);
            post.append('data[type]',this.type);
            post.append('data[uploadMethod]',this.uploadMethod);
            try {
                const response = await axios.post(this.$store.state.SAMCOTEC.r_path , post, {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                });

                if(response.data && response.data.error && response.data.error.message){
                    alert(response.data.error.message);
                    this.fileit = null;
                    this.selectedFile = null
                }
            } catch (error) {
                console.error("Upload failed:", error);
            }
        },
    },
    created() {
        //
    }
}
</script>